export default "__VITE_ASSET__CxhX0OLv__"